import { lazy } from 'react';

export const Dashboard = lazy(() => import('./Dashboard'));
export const SuperadminDashboard = lazy(() => import('./superadmin_dashboard/SuperadminDashboard'));
export const AdminDashboard = lazy(() => import('./admin_dashboard/AdminDashboard'));
export const XpressAdminDashboard = lazy(() => import('./xpress_admin_dashboard/XpressAdminDashboard'));